import React, { useState, useEffect } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import { AppButton } from './AppButton';
import { useI18n } from '../../../i18n';
import './SaveButton.scss';

export interface SaveButtonProps {
  onClick: () => void | Promise<void>;
  hasUnsavedChanges?: boolean;
  disabled?: boolean;
  label?: string;
  className?: string;
}

export const SaveButton: React.FC<SaveButtonProps> = ({
  onClick,
  hasUnsavedChanges = false,
  disabled = false,
  label,
  className,
}) => {
  const { t } = useI18n();
  const resolvedLabel = label ?? t('common.save');
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (!showSuccess) return;
    const timer = setTimeout(() => setShowSuccess(false), 1000);
    return () => clearTimeout(timer);
  }, [showSuccess]);

  const handleClick = async () => {
    setIsLoading(true);
    try {
      await onClick();
      setShowSuccess(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <span data-component="SaveButton" className={className}>
      <AppButton
        variant={hasUnsavedChanges ? 'primary' : 'ghost'}
        onClick={handleClick}
        disabled={disabled}
        loading={isLoading}
        startIcon={showSuccess && !isLoading ? <CheckIcon fontSize="small" /> : undefined}
      >
        {resolvedLabel}
      </AppButton>
    </span>
  );
};
